export const departmentRouteName = {
  index: "departments.index",
};

export const departmentRoute = [
  {
    path: "/departments",
    name: departmentRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "department",
      breadcrumbs: () => {
        return [{ title: "Department" }];
      },
    },
  },
];
